import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4 {...{
      "id": "inbound-ip-addresses"
    }}>{`Inbound IP addresses`}</h4>
    <p>{`We use a set of IP addresses to access your instance. To ensure this connector works, add these IPs to your inbound security rules:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`US`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`EU`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`44.205.89.55`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3.75.65.221`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`44.208.188.173`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`18.197.246.42`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`52.4.194.122`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3.120.223.253`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      